import {ActionTypeStrategy} from '@dcp/configurator';
import {CustomScrollingService} from '../../services/custom-scrolling.service';
import {DEFAULT_HEADER_OFFSET} from '../../search/results/search-sorting/search-sorting.component';
import {NAV_LINK} from '../../product/details/plans-and-pricing/plans-and-pricing-data.service';

export class PageNavigationActionTypeStrategy implements ActionTypeStrategy {
  constructor(private customScrollingService: CustomScrollingService) {}

  public action(): void {
    const pricingSectionId: string = NAV_LINK.id;
    this.customScrollingService.scrollToElementId(pricingSectionId, DEFAULT_HEADER_OFFSET);
  }
}
